module.exports = __webpack_public_path__ + "img/zhiliang.98c19144.png";